<template> 
  <div>
    <div class="line__vertical-mains"></div>
 
    <sub-header :micrositeUrl="micrositeUrl" />
    <div v-if="locations.length > 0" class="map_filter">
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione una torre, clic para ver detalles</span>
                </h1>
        <map-highlight class="canadas_indicator_depto" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators" :type="type"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel"  :desarrollo="desarrollo" :levelId="levelId" :url="url"/>
        <div class="line_horizontal"></div>
        <Availables
            class="availables-mobile"
            :amountAvailables="amountAvailables"
            :nivel="nivel"
            :url="url"
        />
      </div>
      <div class="select__box" :class="selectHide">
        <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        />
        <Availables
            class="availables-desk"
            :amountAvailables="amountAvailables"
            :nivel="nivel"
            :url="url"
        />
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../../core/SubHeader.vue";
import MapHighlight from "../../../core/MapHighlight.vue";
import Select from "../../../core/Select.vue";
import Availables from "../../../core/rediseno/Availables.vue";
import Button from "../../../core/Button.vue";
/* import PopupAvailables from "../../../core/PopupnotAvailables.vue"; */
export default {
  name: "Main",
  components: {
    SubHeader,
    MapHighlight,
    Select,
    Availables,
    Button,
    //PopupAvailables
  },
  data() {
    return {
      id: 35,
      nivel: "towerStage",
      levelId: 0,
      type: "departamentos",
      desarrollo: "canadas_deptos",
      arrFilteredLocations: [],
      url: "canadas_deptos",
      micrositeUrl: "https://www.tresmarias.com.mx/canadas/departamentos",
      imgSet: [
        {
          name: 'canadas_casas',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDeptosCanadas2023.png',
          width: '4472',
          height: '1581',
          id: 35,
          levelId: 0,
          route: 'canadas_deptos',
          nivel: 'towerStage',
          transform: '',
          viewBox: '0 0 4472 1581'
        }
      ],
      indicators: [
        {id: 87, text: 'TORRE 1', transform: 'matrix(1 0 0 1 150.7441 1377.9448)',cxB: 538, cyB: 1311, rB: 40, cxW: 538.5, cyW: 1311.5, rW: 20.5, x1: 1045, y1: 1079, x2: 558.5, y2: 1291.9,  status: true },
        {id: 88, text: 'TORRE 2', transform: 'matrix(1 0 0 1 850.7441 337.9448)',cxB: 1238, cyB: 341.5, rB: 40, cxW: 1238.5, cyW: 341.5, rW: 20.5, x1: 1235, y1: 1099, x2: 1235.5, y2: 371.9,  status: true },
        {id: 90, text: 'TORRE 3', transform: 'matrix(1 0 0 1 1650 1563)', cxB: 1584, cyB: 1540, rB: 40, cxW: 1584.5, cyW: 1540, rW: 20.5, x1: 1580, y1: 1045, x2: 1580.5, y2: 1516, status: true },
        { id: 91, text: 'TORRE 4', transform: 'matrix(1 0 0 1 1480 300)', cxB: 1870, cyB: 280, rB: 40, cxW: 1870.5, cyW: 280, rW: 20.5, x1: 1900, y1: 999, x2: 1870, y2: 300, status: true },
        //nuevos apuntadores abajo: {id: 91, text: 'TORRE 4', transform: 'matrix(1 0 0 1 1760 1430)', cxB: 1900, cyB: 1330, rB: 40, cxW: 1900, cyW: 1330, rW: 20.5, x1: 1900, y1: 1000, x2: 1900, y2: 1310, status: true },
        //nuevos apuntadores abajo: {id: 94, text: 'TORRE 5', transform: 'matrix(1 0 0 1 2000 1560)', cxB: 2140, cyB: 1460, rB: 40, cxW: 2140, cyW: 1460, rW: 20.5, x1: 2140, y1: 967, x2: 2140, y2: 1440, status: true},
        {id: 94, text: 'TORRE 5', transform: 'matrix(1 0 0 1 2130 1563)', cxB: 2070, cyB: 1540, rB: 40, cxW: 2070.5, cyW: 1540, rW: 20.5, x1: 2100, y1: 967, x2: 2070, y2: 1516, status: true},
        {id: 96, text: 'TORRE 6', transform: 'matrix(1 0 0 1 2130 1390)',cxB: 2510, cyB: 1360, rB: 40, cxW: 2510, cyW: 1360, rW: 20.5, x1: 2510, y1: 940, x2: 2510, y2: 1340,  status: true },
        {id: 97, text: 'TORRE 7', transform: 'matrix(1 0 0 1 2760 1390)',cxB: 2710, cyB: 1360, rB: 40, cxW: 2710, cyW: 1360, rW: 20.5, x1: 2710, y1: 940, x2: 2710, y2: 1340,  status: true },
        {id: 98, text: 'TORRE 8', transform: 'matrix(1 0 0 1 3096 1190)', cxB: 3046, cyB: 1160, rB: 40, cxW: 3046.5, cyW: 1160, rW: 20.5, x1: 3046, y1: 940, x2: 3046, y2: 1140, status: true },
      ],
      // si no hay filtro volver rangeFilter a false
      rangeFilter: false
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      return { id: this.id, level: 0 };
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      return arrExistFilter;
    },
    amountAvailables(){
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.available > 0
      );
      
      return newArrfiltered;
    },
    showPopup(){
      if(this.amountAvailables.length==0){
        return true
      }else{
        return false
      }
    },
    selectHide(){
      if(this.rangeFilter == false){
        return 'u__dipslay--none'
      }else{
        return ''
      }
    }
  }, 
  methods: {
    ...mapActions(["getTowerStage", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.clearCoords();
    await this.getTowerStage(this.development);
  },
  async beforeDestroy(){
    await this.clearCoords()
  }
};
</script>
<style>
.canadas_indicator_depto .st1.st2{
  font-size: 8rem;
}
.canadas_indicator_depto .st3{
  stroke-width: 8;
}
.canadas_indicator_depto polygon{
  opacity: 0.8!important;
}
</style>
